import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useMangoApiClient } from '~/atoms/MangoApi'

import { ApiError } from '@mangovoice/types'

export interface TimeZone {
  group: string
  label: string
  iana_time_zone: string
}

interface UseGetTimeZonesParams {
  options?: Omit<UseQueryOptions<TimeZone[], ApiError>, 'queryKey'>
}

export const useGetTimeZones = ({ options }: UseGetTimeZonesParams = {}) => {
  const api = useMangoApiClient()

  return useQuery<TimeZone[], ApiError>({
    queryKey: ['timeZones'],
    queryFn: async () => {
      const { ok, data } = await api.pbxes.getTimeZones()

      if (!ok) {
        return Promise.reject(data as ApiError)
      }

      return data as TimeZone[]
    },
    ...options,
    retry: options?.retry ?? false,
    staleTime: options?.staleTime ?? Infinity,
  })
}
